<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>关联环境模型</h3>
          </div>

        </div>
        <div class="div-step">
          <el-steps :active="1" align-center>
            <el-step title="添加决策模型"></el-step>
            <el-step title="关联环境模型"></el-step>
            <el-step title="关联生长模型"></el-step>
            <!-- <el-step title="绑定城市"></el-step>
            <el-step title="绑定摄像头"></el-step>
            <el-step title="添加设备调控"></el-step>
            <el-step title="添加大棚告警"></el-step> -->
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <div class="info-content-container">
          <div class="table_content1" style="margin-top: 10px">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
              <el-row>
                <el-col :span="22">
                  <el-form-item label="环境模型：" prop="modelEvnId">
                    <el-select v-model="ruleForm.modelEvnId" placeholder="请选择环境模型" clearable>
                      <el-option v-for="item in modelEvnArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <i title="添加更多环境模型" @click="handleAddMoreEvn()" class="el-icon-circle-plus-outline add-more"></i>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="环境传感器：" prop="deviceNumericalId">
                    <el-select v-model="ruleForm.deviceNumericalId" placeholder="请选择环境传感器" clearable>
                      <el-option v-for="item in Numericals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
            <div style="display: flex;justify-content: space-around;">
              <div></div>
              <div class="pagination-container" style="margin-left: 12rem;">
                <div class="page"></div>
                <div slot="footer" class="div-footer">
                  <el-button type="primary" @click="handleSave">保 存</el-button>
                </div>
              </div>

              <div style="margin-top: 1.2rem;">
                <el-button type="primary" @click="handlePrev">上一步</el-button>
                <el-button type="primary" @click="handleNext">下一步</el-button>
                <el-button type="primary" @click="handleReturn">返回决策模型</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        // 添加编辑弹窗表单字段
        id: '',
        groupId: '',
        modelEvnId: '',
        deviceNumericalId: ''
      },
      rules: {
        // 添加编辑弹窗表单规则
        modelEvnId: [
          {
            required: true,
            message: '请选择环境模型',
            trigger: 'change'
          }
        ],
        deviceNumericalId: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ]
      },
      modelEvnArray: [], // 大棚名称数组
      Numericals: []
    }
  },
  created() {
    this.ruleForm.id = this.$route.query.decisionId
    // this.ruleForm.groupId = this.$route.query.groupId;

    // 获取详情
    this.getDetail()
  },
  methods: {
    // 获取详情
    getDetail() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        return
      }

      this.$api.growthModel.getGrowthModelDecision({ id: this.ruleForm.id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data

          // 获取环境模型列表
          this.getGrowthModelEvnAll()
        }
      })
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '生长模型切换中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          this.$api.growthModel.saveGrowthModelDecision(this.ruleForm).then((res) => {
            loading.close()
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            }
          })
        }
      })
    },
    // 获取环境模型列表
    getGrowthModelEvnAll() {
      if (!this.ruleForm.groupId || this.ruleForm.groupId == '') {
        return
      }

      this.$api.growthModel.getGrowthModelEvnAll({ groupId: this.ruleForm.groupId }).then((res) => {
        if (res.code == 200) {
          this.modelEvnArray = res.data
        }
      })
      this.$api.device
        .getNumericalsByGroupId({
          groupId: this.ruleForm.groupId
        })
        .then((res) => {
          this.Numericals = res.data
        })
    },
    // 添加更多环境模型
    handleAddMoreEvn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: 'second'
        }
      })
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {}
      })
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `addDecisionModel`,
        query: {
          decisionId: this.$route.query.decisionId
        }
      })
    },
    // 下一步
    handleNext() {
      this.$router.push({
        name: `relationGrowthModel`,
        query: {
          decisionId: this.$route.query.decisionId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }

  .add-more {
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    color: #256bff;
    cursor: pointer;
  }
}
</style>